import React from 'react';
import { Box } from '@material-ui/core';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const FiltersButton = ({ illustrative = false, ...props }) => {
  const t = useLocalizedMessage();
  return (
  <Box
    display="inline-flex"
    alignItems="center"
    gap={1}
    px={2}
    py={1}
    bgcolor="#f5f5f5"
    border="1px solid #e0e0e0"
    borderRadius={2}
    ml="auto" // Push to right in flex row
    {...props}
  >
    <Box width={14} height={14} bgcolor="#bdbdbd" style={{ clipPath: 'polygon(0 0, 100% 0, 60% 60%, 60% 100%, 40% 100%, 40% 60%)' }} />
    {illustrative ? t('searchInterface.preview.filters') : <Box width={40} height={8} bgcolor="#e0e0e0" borderRadius={4} />}
  </Box>
  );
};

export default FiltersButton;
